'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHALLENGE_IFRAME_3DSV2 = exports.CHALLENGE_IFRAME_3DSV2 = 'challengeIframe3DSv2';
var CHALLENGE_FORM_3DSV2 = exports.CHALLENGE_FORM_3DSV2 = 'challengeForm3DSv2';
var HIDDEN_IFRAME_3DSV2 = exports.HIDDEN_IFRAME_3DSV2 = 'hiddenIframe3DSv2';
var HIDDEN_FORM_3DSV2 = exports.HIDDEN_FORM_3DSV2 = 'hiddenForm3DSv2';

var CHALLENGE_WINDOW_SIZE_250X400 = exports.CHALLENGE_WINDOW_SIZE_250X400 = '01';
var CHALLENGE_WINDOW_SIZE_390X400 = exports.CHALLENGE_WINDOW_SIZE_390X400 = '02';
var CHALLENGE_WINDOW_SIZE_500X600 = exports.CHALLENGE_WINDOW_SIZE_500X600 = '03';
var CHALLENGE_WINDOW_SIZE_600X400 = exports.CHALLENGE_WINDOW_SIZE_600X400 = '04';
var CHALLENGE_WINDOW_SIZE_FULL_SCREEN = exports.CHALLENGE_WINDOW_SIZE_FULL_SCREEN = '05';

var QUICK_DEPOSIT_HORIZONTAL_CLASSNAME = exports.QUICK_DEPOSIT_HORIZONTAL_CLASSNAME = 'qd-horizontal';
var QUICK_DEPOSIT_VERTICAL_CLASSNAME = exports.QUICK_DEPOSIT_VERTICAL_CLASSNAME = 'qd-vertical';
var QUICK_DEPOSIT_LOADING_SPINNER_CLASSNAME = exports.QUICK_DEPOSIT_LOADING_SPINNER_CLASSNAME = 'qd__loading-spinner';